export const fareHeaderColorVariants = {
  ECONOMY_MINI: 'bg-bt-green text-bt-blue-dark',
  ECONOMY_BASIC: 'bg-bt-green text-bt-blue-dark',
  ECONOMY_CLASSIC: 'bg-bt-green text-bt-blue-dark',
  ECONOMY_FLEX: 'bg-bt-green text-bt-blue-dark',
  CORPORATE_ECONOMY_FLEX: 'bg-bt-green text-bt-blue-dark',
  CORPORATE_BUSINESS: 'bg-bt-blue-ui text-white',
  BUSINESS: 'bg-bt-blue-ui text-white',
  INTERLINE_ECONOMY: 'bg-bt-green text-bt-blue-dark',
  INTERLINE_BUSINESS: 'bg-bt-blue-ui text-white',
  BUSINESS_EXPERIENCE: 'bg-bt-blue-ui text-white'
} as const
